const introduce = () => import('@/views/winter-camp/pages/introduce')
const signup = () => import('@/views/winter-camp/pages/signup')
// const signup = () => import('@/views/winter-camp/pages/Test1')
const signsuccess = () => import('@/views/winter-camp/pages/signsuccess')
const home = () => import('@/views/winter-camp/pages/home')
const activity = () => import('@/views/winter-camp/pages/activity')

export default [
    {
        path: ':identify(student|teacher|visitor)/introduce',
        alias: ':identify(student|teacher)/overtime',
        component: introduce,
        meta: {
            title: '寒假提分营'
        },
    },
    {
        path: 'signup',
        component: signup,
        meta: {
            title: '寒假提分营'
        },
    },
    {
        path: 'home',
        component: home,
        meta: {
            title: '寒假提分营'
        },
    },
    {
        path: 'activity',
        component: activity,
        meta: {
            title: '寒假提分营'
        },
    },
    {
        path: 'signsuccess',
        component: signsuccess,
        meta: {
            title: '寒假提分营'
        },
    },
]



// WEBPACK FOOTER //
// ./src/router/winter-camp.js